/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const delay = (time = 10): Promise<void> => new Promise(resolve => setTimeout(resolve, time));

const callCbWithArrayItemsInAsyncOrder = <T>(asyncCallback: (arrItem: T) => Promise<any>, arr: T[], index = 0): Promise<void> => (
    asyncCallback(arr[index])
        .then(() => {
            if ((index + 1) < arr.length) {
                return callCbWithArrayItemsInAsyncOrder<T>(asyncCallback, arr, index + 1);
            }
        })
);

export {
    delay,
    callCbWithArrayItemsInAsyncOrder,
};
